/**
 * Parse a stage distance that may use a decimal comma (e.g. "20,1") or dot,
 * and may arrive as either camelCase or snake_case from the API.
 */
export const parseStageLength = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const normalized = String(value)
    .trim()
    .replace(/\s/g, "")
    .replace(/,/g, ".");
  const numeric = Number(normalized);

  return Number.isFinite(numeric) ? numeric : null;
};

export const resolveStageLengthValue = (
  source: Record<string, unknown> | null | undefined
): number | null => {
  if (!source) {
    return null;
  }

  return parseStageLength(source.stageLength ?? source.stage_length);
};
